<div style="display: flex;gap:24px;padding: 22px">
  <div style="flex: 1">
    <mat-form-field style=";width: 100%">
      <textarea [(ngModel)]="jsonInput" data-testid="jsonTextArea" matInput
                placeholder="Paste JSON array here" rows="max"
                style="height: 75vh;font-size:14px;width: 100%"></textarea>
    </mat-form-field>
    <button (click)="saveToFirestore()" data-testid="saveToFirestore" mat-flat-button>Save</button>

    @if (errorMessage) {
      <div>{{ errorMessage }}</div>
    }
  </div>
  <div data-testid="siteCategoriesContainer" style="flex: 1">

    @let sites = siteMessage$ | async;
    @if (sites) {
      <div style="height: 75vh;overflow: auto;padding: 16px;border-radius: 24px;background: #f4f4ff">
        <pre>{{ sites | json }}</pre>
      </div>
      <button (click)="copyToClipboard(sites)" data-testid="copyToClipboard" mat-flat-button style="margin-top: 16px;">
        Copy JSON
      </button>
    }

  </div>
</div>



